import React from "react";
import Navbar from "../components/App/Navbar";
import Footer from "../components/App/Footer";
import Layout from "../components/App/Layout";
import Banner from "../components/Index/Banner";
import OurSolutions from "../components/Index/OurSolutions";
import OurFeatures from "../components/Index/OurFeatures";
import Testimonials from "../components/Index/Testimonials";
import ProjectStartArea from "../components/Index/ProjectStartArea";
import CapabilitiesMatrix from "../components/Common/CapabilitiesMatrix";
import { CareerPlatformTeaser } from "../components/CareerPlatform/CareerPlatformContent";

const Home = () => {
  return (
    <Layout>
      <Navbar />
      <Banner />
      <OurSolutions />
      <OurFeatures />
      <CapabilitiesMatrix />
      <CareerPlatformTeaser />
      <Testimonials />
      <ProjectStartArea />
      <Footer />
    </Layout>
  );
};

export default Home;
